import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import notificationsService from "../../services/notifications.service";
import { NotificationDetail } from "../../components/notifications/NotificationDetail";
import { CircularProgress } from "@mui/material";

export const Notification = () => {
  const [notificationInfo, setNotificationInfo] = useState({
    id: "",
    category: "",
    title: "",
    msg: "",
    target: "",
    create_user: "",
    start_date: "",
    end_date: "",
    created: "",
    status: "",
  });

  const notificationId = useParams().notificationId;
  const location = useLocation();
  const type = new URLSearchParams(location.search).get("type");

  const [isLoadingInfo, setIsLoadingInfo] = useState(true);
  const [isAction, setIsAction] = useState(false);

  useEffect(() => {
    const fetchNotification = async () => {
      setIsLoadingInfo(true);

      const response = await notificationsService.getById(notificationId, type);
      if (response.status === 200) {
        setNotificationInfo(response.notification);
        setIsLoadingInfo(false);
      } else {
        console.error("Failed to fetch notification details");
      }
    };
    fetchNotification();
  }, []);

  if (isLoadingInfo) {
    return <CircularProgress size={24} color="secondary" />;
  }

  return (
    <>
      {notificationInfo && (
        <NotificationDetail
          notificationId={notificationId}
          notificationInfo={notificationInfo}
        ></NotificationDetail>
      )}
    </>
  );
};
